import React , { useState, useEffect }  from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from "./DashboardTitle";
import { Link, useNavigate,useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import constants from "../../services/constants";
import { getOfferListIdFormData} from "../../services/routes.services";
import Modal from 'react-bootstrap/Modal'
import { IoClose } from "react-icons/io5";


const DashBoardOffer =(props)=>{
 const [show, setShow] = useState(false);
    const [getAllData, setGetAllData] = useState(null);
    const [getDetails, setDetails] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(false);
        const { token } = useSelector((state) => state.auth);
        const navigate = useNavigate();
        const smoothScroll = () => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          };
          
              const offerData = props.offerData
          
              const handleOpen = (data) => {
                setModalData(data)
              setModalOpen(true);
            };
            const handleClose = () => setShow(false);
               
                const handleShow = (Busnisslist) => {
                    setShow(true);
                   
                    getOfferListIdFormData(Busnisslist._id)
                        .then((res) => {
                            setDetails(res.data.offer[0]);
                                
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                        
                        
                }
                const handleEditPage=(offerDetails)=>{
                    navigate("/offer-create", { state: { offerDetails: offerDetails } });
                }
    return(
<div className={Style.eventPost + ' ' + Style.RightRow}>
<h4 className={Style.dashTitle}>Offers Posted</h4>
<Link to="/offer-create" className={Style.greenBtn} onClick={smoothScroll}>Add Offer</Link>
 <div className={Style.offersRow}>
    {offerData && offerData.length > 0 ?(
    <>
        {offerData.slice(0, 2).map((offerList)=>{
            return(
                <div className={Style.listCol} key={offerList._id}>
                    <figure>
                        {/* <img src={require('../../assest/images/past-img.png')} /> */}
                        <img src={constants.IMAGE_BASE_URL+'business/'+offerList.image} alt={offerList.company} />
                    </figure>
                    <div className={Style.listDetail}>
                        <span>{offerList.offerDescription}</span>
                        <h4>{offerList.company}</h4>
                        <div className={Style.listOption}>
                            <a href="#" onClick={(e) => {e.preventDefault();handleEditPage(offerList)}}>Edit</a>
                            <a href="#" onClick={(e) => {e.preventDefault();handleShow(offerList)}} className={Style.discountBtn}>More Details</a>  
                        </div>
                    </div>
                </div>
            )
        })}
        <div className={Style.viewBtn}>
            <Link to="/myoffer" onClick={smoothScroll}>View More</Link>
        </div>
    </>
    ) : null}
</div> 
<Modal show={show} onHide={handleClose}>
    <Modal.Body>
        <div className={Style.discountPopup}>
            
            <span className={Style.closePopup} onClick={handleClose}>X</span>
            {getDetails &&
            
                <div className={Style.discountDetails}>
                    <div className={Style.companyLogo}>
                            <img src={constants.IMAGE_BASE_URL+'business/'+getDetails.image} />
                    </div>
                    <div className={Style.offerHead}>
                        <h2>
                            
                            {getDetails.package}
                        </h2>
                        
                    </div>
                    <div className={Style.offerDetails}>
                        <table role="none">
                            <tbody><tr>
                                <td className={Style.left}>Business Name</td>
                                <td className={Style.right}>{getDetails.companyName}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>Category</td>
                                <td className={Style.right}>{getDetails.category}</td>
                            </tr>
                            
                            <tr>
                                <td className={Style.left}>Business Contact No.</td>
                                <td className={Style.right}> {getDetails.businessOfferContactNumber}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>CITY</td>
                                <td className={Style.right}>{getDetails.city} </td>
                            </tr>
                            
                            
                            <tr>
                                <td className={Style.left}>Description</td>
                                <td className={Style.right}>{getDetails.offerDescription}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>Posted By Name</td>
                                <td className={Style.right}>{getDetails.alumniName}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>Coupon Code</td>
                                <td className={Style.right}>{getDetails.couponCode}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>Email</td>
                                <td className={Style.right}>{getDetails.email}</td>
                            </tr>
                            <tr>
                                <td className={Style.left}>Batch</td>
                                <td className={Style.right}>{getDetails.batch}</td>
                            </tr>
                        </tbody> 
                        </table>
                    </div>
                    {/* <a href="#" onClick={(e) => {e.preventDefault();handleEditPage(getDetails)} }className={Style.greenBtn}>Edit</a> */}
                    </div>
                }  
        </div>
    </Modal.Body>
</Modal>
</div>
)
}
export default DashBoardOffer;